<div *ngIf="reportType == 'BookoutstandingInDetails'">

  <!-- Buttons -->
  <div style="margin-left: 80%; margin-top: 2%;" class="noPrint">
    <button (click)=" exportExcel('Contract_InDetails_Report')" 
            mat-raised-button color="primary">
      Export
    </button>

    <button class="btn btn-primary" (click)="printPageA4()">Print</button>
    <button mat-button mat-dialog-close>Close</button>
  </div>


  <!-- PRINT SECTION -->
  <div id="print-section">

    <!-- ================= MAIN HEADER (FIRST PAGE ONLY) ================= -->
    <div class="main-header-wrapper">
      <table class="table table-bordered" style="width:100%; border-collapse:collapse; margin-bottom: 0;">
        <thead>
          <tr>
        <td style="font-size: 18px; font-weight: bold; text-align: center; white-space: nowrap; padding: 8px;border-left:1px solid black;border-top:1px solid black;border-bottom:1px solid black;border-right:1px solid black;">
          हिंदुस्तान प्रकाशन संस्था 
        </td>
        <td style="font-size: 20px; font-weight: bold; text-align: center;border-bottom:1px solid black;border-top:1px solid black;border-right:1px solid black;">
          Book Outstanding Report
        </td>
        <td style="font-size: 18px; text-align: right;font-weight: bold; white-space: nowrap; padding: 8px;border-bottom:1px solid black;border-top:1px solid black;border-right:1px solid black;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </td>
      </tr>

               <tr style="border-top: 1px solid black;">
        <td style="padding: 8px;font-weight: bold;font-size: 18px;text-align: center;border-right:1px solid black;border-left:1px solid black;"> विवेक पुस्तक प्रकाशन</td>
        <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px;border-right:1px solid black;border-left:1px solid black;">
           All In Detail
        </td>
        <td style="font-size: 16px; text-align: right; font-weight: bold; white-space: nowrap; padding: 8px;border-right:1px solid black;border-top:1px solid black;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </td>
      </tr>
        </thead>
      </table>
    </div>

    <!-- ================= MAIN DATA TABLE ================= -->
    <table class="table table-bordered" style="width:100%; border-collapse:collapse;">

      <!-- ================= COLUMN HEADER (REPEAT EVERY PAGE) ================= -->
      <thead class="repeat-header">
        <tr style=" font-weight: bold;">
          <th style="border:1px solid black; padding:6px;">Invoice No</th>
          <th style="border:1px solid black; padding:6px;">Invoice Date</th>
          <th style="border:1px solid black; padding:6px;">Book Seller Name</th>
          <th style="border:1px solid black; padding:6px;">Contact No</th>
          <th style="border:1px solid black; padding:6px;">Invoice Amt</th>
          <th style="border:1px solid black; padding:6px;">Received<br>Amount</th>
          <th style="border:1px solid black; padding:6px;">Credit<br>Amount</th>
          <th style="border:1px solid black; padding:6px;">Unpaid<br>Amount</th>
        </tr>
      </thead>


      <!-- ================= BODY ================= -->
      <tbody *ngFor="let data of OutstandingInDetailFormBeans">

        <tr>
          <td colspan="8" style="text-align:center; font-weight:bold; border:1px solid black; padding:6px;font-size: 16px">
            Office Representative: {{data.off_rep_name}}
          </td>
        </tr>

        <ng-container *ngFor="let data1 of data.rep_data">

          <tr >
            <td colspan="8" style="font-weight:bold; border:1px solid black; padding:6px;">
              Representative: {{data1.rep_name}} ({{data1.rep_mobile_no}})
            </td>
          </tr>

          <tr *ngFor="let data2 of data1.inv_data" style="text-align:center;">
            <td style="border:1px solid black; padding:6px;">{{ data2.invoice_no }}</td>
            <td style="border:1px solid black; padding:6px;">{{ data2.invoice_date }}</td>

            <td style="text-align:left; max-width:300px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; border:1px solid black; padding:6px;"
                title="{{ data2.book_seller_name }}">
              {{ data2.book_seller_name }}
            </td>

            <td style="border:1px solid black; padding:6px;">{{ data2.book_seller_mobile_no }}</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{ data2.inv_amt }}</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{ data2.rcv_amt || "0" }}</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{ data2.credit_amt }}</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{ data2.unpaid_amt }}</td>
          </tr>

          <tr style="font-weight:bold; ">
            <td colspan="4" style="text-align:right; border:1px solid black; padding:6px;">Representative Total ({{data1.rep_name}})</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{data1.inv_amt_total}}</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{data1.net_amt_total}}</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{data1.crdt_amt_total}}</td>
            <td style="text-align:right; border:1px solid black; padding:6px;">{{data1.unpaid_amt_total}}</td>
          </tr>

        </ng-container>

        <tr style="font-weight:bold; background:#f4b084;">
          <td colspan="4" style="text-align:right; border:1px solid black; padding:6px;">Office Representative Total: {{data.off_rep_name}}</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{data.off_inv_amt_total}}</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{data.off_net_amt_total}}</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{data.off_crdt_amt_total}}</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{data.off_unpaid_amt_total}}</td>
        </tr>

      </tbody>


      <!-- ================= GRAND TOTAL ================= -->
      
        <tr style="background:#c8753f;  font-weight:bold;">
          <td colspan="4" style="text-align:right; border:1px solid black; padding:6px;">Grand Total</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{ OutStandingIDTotal }}</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{ OutStandingIDNetAmtTotal }}</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{ OutStandingIDCrdtTotal }}</td>
          <td style="text-align:right; border:1px solid black; padding:6px;">{{ OutStandingIDUnPaidTotal }}</td>
        </tr>
      

    </table>

  </div>

</div>


<!-- ================= TYPESCRIPT PRINT METHOD ================= -->
<!-- 
printPageA4() {
  const printContent = document.getElementById('print-section');
  const WindowPrt = window.open('', '', 'width=1400,height=900');

  WindowPrt.document.write(`
    <html>
      <head>
        <title>Book Outstanding Report</title>
        <style>

          @page {
            size: A3 landscape;
            margin: 8mm;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 13px;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            margin: 0;
            padding: 0;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid black;
            padding: 6px;
          }

          .main-header-wrapper {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          .repeat-header {
            display: table-header-group;
          }

          @media print {
            .repeat-header {
              display: table-header-group !important;
            }

            .main-header-wrapper {
              display: block;
            }

            tr {
              page-break-inside: avoid !important;
            }

            tbody tr {
              page-break-inside: avoid !important;
            }

            tbody {
              page-break-inside: auto;
            }
          }

        </style>
      </head>

      <body>${printContent?.innerHTML}</body>

    </html>
  `);

  WindowPrt.document.close();
  WindowPrt.focus();

  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 600);
}
-->



<div *ngIf="reportType == 'Bookoutstandingbriefly'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">
    <button (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">Export</button>
    <button class="btn btn-primary" (click)="printPageA41()">Print</button>
    <button mat-button mat-dialog-close>Close</button>
  </div>

  <!-- PRINT SECTION -->
  <div id="print-section">

    <!-- ================= MAIN HEADER (FIRST PAGE ONLY) ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;">

        <thead>
          <tr>
            <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;border-left:1px solid black;border-right:1px solid black;border-top:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था 
            </td>

            <td style="font-size:20px; font-weight:bold; text-align:center; padding:8px;border-right:1px solid black;border-top:1px solid black;">
              Book Outstanding Report 
            </td>

            <td style="font-size:18px; text-align:right; padding:8px;border-right:1px solid black;border-top:1px solid black; font-weight: bold;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <tr style="border-top:1px solid black;">
            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;border-left:1px solid black;">
               विवेक पुस्तक प्रकाशन
            </td>

            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;">
              All Briefly
            </td>

            <td style="font-size:16px; text-align:right; padding:8px; white-space:nowrap;border-right:1px solid black; font-weight: bold;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }}
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>
        </thead>

      </table>
    </div>

    <!-- ================= MAIN DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- ================= COLUMN HEADER (REPEAT EVERY PAGE) ================= -->
      <thead class="repeat-header">
        <tr style="font-weight:bold; background:#e4e4e4;">
          <th style="border:1px solid black; padding:6px; text-align:left;">Representative Name</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Contact No</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Invoice<br>Amount</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Paid<br>Amount</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Credit Amount</th>
          <th style="border:1px solid black; padding:6px; text-align:center;">Unpaid Amount</th>
        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody>

        <!-- LOOP OFFICE REPRESENTATIVE -->
        <ng-container *ngFor="let data of OutstandingB">

          <!-- OFFICE REP HEADER -->
          <tr >
            <td colspan="6" style="border:1px solid black; padding:8px; font-weight:bold; font-size:18px;">
              Office Representative Name : {{data.off_rep_name}}
            </td>
          </tr>

          <!-- REPRESENTATIVE ROWS -->
          <tr *ngFor="let data1 of data.rep_data">

            <td style="border:1px solid black; padding:6px;">
              {{data1.rep_name}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:center;">
              {{data1.rep_mobile_no}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.inv_amt_total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.net_amt_total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.crdt_amt_total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data1.unpaid_amt_total}}
            </td>

          </tr>

          <!-- SUBTOTAL ROW -->
          <tr style=" font-weight:bold;background:#f4b084;">
            <td colspan="2" style="border:1px solid black; padding:6px;">
              Total: {{data.off_rep_name}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.inv_Total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.paid_Total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.crdt_Total}}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;">
              {{data.bal_Total}}
            </td>
          </tr>

        </ng-container>

        <!-- ================= GRAND TOTAL ================= -->
        <tr style="background:#c8753f; font-weight:bold; color:white; font-size:16px;">
          <td colspan="2" style="border:1px solid black; padding:8px;">
            Grand Total:
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalInvAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalPaidAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalCrdtAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalUnpaidAmount }}
          </td>
        </tr>

      </tbody>

    </table>

  </div>

</div>



<div *ngIf="reportType == 'unpaidOutstandingInDetails'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">
    <button mat-raised-button color="primary"
            (click)="exportExcel('Unpaid_Outstanding_InDetails_Report')">
      Export
    </button>

    <button class="btn btn-primary" (click)="printPageA4()">Print</button>

    <button mat-button mat-dialog-close>Close</button>
  </div>

  <!-- PRINT AREA -->
  <div id="print-section">

    <!-- ================= FIRST PAGE HEADER ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;">

        <thead>

          <!-- TITLE ROW -->
          <tr>
            <td colspan="2" style="font-size:18px; font-weight:bold; padding:8px;text-align:center;border-left:1px solid black;border-top:1px solid black;border-right:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था
            </td>

            <td colspan="3" style="font-size:20px; font-weight:bold; padding:8px; text-align:center;border-right:1px solid black;border-top:1px solid black;">
              Book Outstanding Report 
            </td>

            <td colspan="4" style="font-size:18px; padding:8px; text-align:right;font-weight:bold;border-top:1px solid black;border-right:1px solid black;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <!-- SUBTITLE -->
          <tr style="border-top:1px solid black;">
            <td colspan="2" style="font-size:18px; padding:8px; text-align:center; font-weight:bold;border-right:1px solid black;border-left:1px solid black;">
              विवेक पुस्तक प्रकाशन
            </td>

            <td colspan="3" style="font-size:18px; padding:8px; text-align:center; font-weight:bold;border-right:1px solid black;">
              Unpaid Outstanding In Details
            </td>

            <td colspan="4" style="font-size:16px; padding:8px; text-align:right; white-space:nowrap;font-weight:bold;border-right:1px solid black;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }}  
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

        </thead>

      </table>
    </div>

    <!-- ================= MAIN TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- COLUMN HEADERS — WILL REPEAT ON EVERY PAGE -->
      <thead class="repeat-header">
        <tr style="font-weight:bold; ">

          <th style="border:1px solid black; padding:6px; font-size:16px;">Invoice No</th>
          <th style="border:1px solid black; padding:6px; font-size:16px;">Invoice Date</th>

          <th style="border:1px solid black; padding:6px; font-size:16px; width:330px;">
            Book Seller Name
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px;">Contact No</th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Invoice Amt</th>
          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Received Amt</th>
          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Credit Amt</th>
          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">Unpaid Amt</th>

        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody *ngFor="let data of UnpaidOutstandingInDetailFormBeans">

        <!-- OFFICE REP NAME -->
        <tr >
          <td colspan="8" 
              style="border:1px solid black; font-size:16px;  padding:8px; text-align:center;font-weight:bold;">
            Office Representative: {{ data.off_rep_name }}
          </td>
        </tr>

        <!-- REP LEVEL -->
        <ng-container *ngFor="let data1 of data.rep_data">

          <tr >
            <td colspan="8" 
                style="border:1px solid black; padding:8px; font-size:14px; font-weight:bold;">
              Representative: {{ data1.rep_name }} ({{ data1.rep_mobile_no }})
            </td>
          </tr>

          <!-- INVOICE ROWS -->
          <tr *ngFor="let data2 of data1.inv_data">
            <td style="border:1px solid black; padding:6px;">{{ data2.invoice_no }}</td>
            <td style="border:1px solid black; padding:6px;">{{ data2.invoice_date }}</td>

            <td style="border:1px solid black; padding:6px; text-align:left;
                       max-width:330px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;"
                title="{{data2.book_seller_name}}">
              {{ data2.book_seller_name }}
            </td>

            <td style="border:1px solid black; padding:6px;">{{ data2.book_seller_mobile_no }}</td>

            <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.inv_amt }}</td>
            <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.rcv_amt || '0' }}</td>
            <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.credit_amt }}</td>
            <td style="border:1px solid black; padding:6px; text-align:right;">{{ data2.unpaid_amt }}</td>
          </tr>

          <!-- REPRESENTATIVE TOTAL -->
          <tr >
            <td colspan="4" 
                style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              Representative Total: {{ data1.rep_name }}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.inv_amt_total }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.net_amt_total }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.crdt_amt_total }}
            </td>
            <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;">
              {{ data1.unpaid_amt_total }}
            </td>
          </tr>

        </ng-container>

        <!-- OFFICE REPRESENTATIVE TOTAL -->
        <tr >
          <td colspan="4" 
              style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            Office Representative Total: {{ data.off_rep_name }}
          </td>

          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_inv_amt_total }}
          </td>
          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_net_amt_total }}
          </td>
          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_crdt_amt_total }}
          </td>
          <td style="border:1px solid black; padding:6px; text-align:right; font-weight:bold;background:#f4b084;">
            {{ data.off_unpaid_amt_total }}
          </td>
        </tr>

      </tbody>

      <!-- ================= GRAND TOTAL ================= -->
    
        <tr style="background:#c8753f; color:white; font-weight:bold; font-size:17px;">
          <td colspan="4" style="border:1px solid black; padding:8px; text-align:right;">
            Grand Total:
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDTotal }}
          </td>
          <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDNetAmtTotal }}
          </td>
          <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDCrdtTotal }}
          </td>
          <td style="border:1px solid black; padding:8px; text-align:right;">
            {{ UnpaidOutStandingIDUnPaidTotal }}
          </td>
        </tr>
      

    </table>

  </div>

</div>



<!-- unpaidOutstandingbriefly -->
<div *ngIf="reportType == 'unpaidOutstandingbriefly'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">
    <button mat-raised-button color="primary"
            (click)="exportExcel('Unpaid_Outstanding_Brief_Report')">Export</button>

    <button class="btn btn-primary" (click)="printPageA41()">Print</button>

    <button mat-button mat-dialog-close>Close</button>
  </div>

  <!-- PRINT SECTION -->
  <div id="print-section">

    <!-- ================= MAIN HEADER (FIRST PAGE ONLY) ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;">
        <thead>

          <!-- MAIN TITLE ROW -->
          <tr>
            <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;border-left:1px solid black;border-right:1px solid black;border-top:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था 
            </td>

            <td style="font-size:20px; font-weight:bold; text-align:center; padding:8px;border-top:1px solid black;border-right:1px solid black;">
              Book Outstanding Report
            </td>

            <td style="font-size:18px; text-align:right; padding:8px; white-space:nowrap;border-right:1px solid black;border-top:1px solid black;font-weight:bold;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <!-- SUB TITLE ROW -->
          <tr style="border-top:1px solid black;">
            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;border-left:1px solid black;">
              विवेक पुस्तक प्रकाशन
            </td>

            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;">
              Unpaid Outstanding - Briefly
            </td>

            <td style="font-size:16px; text-align:right; padding:8px; white-space:nowrap;border-right:1px solid black;font-weight:bold;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }} 
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

        </thead>
      </table>
    </div>

    <!-- ================= DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- COLUMN HEADER — REPEATS ON EVERY PAGE -->
      <thead class="repeat-header">
        <tr style="font-weight:bold; ">

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:left; width:30%;">
            Representative Name
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:center; width:20%;">
            Contact No
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Invoice Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Paid Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Credit Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Unpaid Amount
          </th>

        </tr>
      </thead>

      <!-- ================= BODY SECTION ================= -->
      <tbody>

        <!-- LOOP OFFICE REPRESENTATIVE -->
        <ng-container *ngFor="let data of UnpaidOutstandingB">

          <!-- OFFICE REP HEADER -->
          <tr >
            <td colspan="6"
                style="border:1px solid black; padding:6px; font-size:14px; font-weight:bold; text-align:center;">
              Office Representative : {{ data.off_rep_name }}
            </td>
          </tr>

          <!-- REPRESENTATIVE ROWS -->
          <tr *ngFor="let data1 of data.rep_data">

            <td style="border:1px solid black; padding:6px; font-size:14px;">
              {{ data1.rep_name }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:center;">
              {{ data1.rep_mobile_no }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ data1.inv_amt_total }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ data1.net_amt_total }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ data1.crdt_amt_total }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ data1.unpaid_amt_total }}
            </td>
          </tr>

          <!-- OFFICE REP TOTAL -->
          <tr style=" font-weight:bold;background:#f4b084;">
            <td colspan="2" style="border:1px solid black; padding:6px;font-size:14px;">
              Total: {{ data.off_rep_name }}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;font-size:14px;">
              {{ data.inv_Total }}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;font-size:14px;">
              {{ data.paid_Total }}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;font-size:14px;">
              {{ data.crdt_Total }}
            </td>

            <td style="border:1px solid black; padding:6px; text-align:right;font-size:14px;">
              {{ data.bal_Total }}
            </td>
          </tr>

        </ng-container>

        <!-- GRAND TOTAL -->
        <tr style="background:#c8753f; font-weight:bold; color:white; font-size:16px;">
          <td colspan="2" style="border:1px solid black; padding:8px;">
            Grand Total:
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ unpaidtotalInvAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ unpaidtotalPaidAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ unpaidtotalCrdtAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;border-right:1px solid black;">
            Rs-{{ unpaidtotalUnpaidAmount }}
          </td>
        </tr>

      </tbody>

    </table>

  </div>

</div>



<div *ngIf="reportType == 'OfficeRepbriefly'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">

    <button mat-raised-button color="primary"
            (click)="exportExcel('Office_Rep_Outstanding_Brief_Report')">
      Export
    </button>

    <button class="btn btn-primary" (click)="printPage43()">Print</button>

    <button mat-button mat-dialog-close>Close</button>
  </div>

  <!-- PRINT SECTION -->
  <div id="print-section">

    <!-- ================= MAIN HEADER (FIRST PAGE ONLY) ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;margin-right:10%;">
        <thead>

          <!-- TITLE ROW -->
          <tr>
            <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;border-left:1px solid black;border-right:1px solid black;border-top:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था 
            </td>

            <td style="font-size:20px; font-weight:bold; text-align:center; padding:8px;border-top:1px solid black;border-right:1px solid black;">
              Book Outstanding Report 
            </td>

            <td style="font-size:18px; text-align:right; padding:8px; white-space:nowrap;border-top:1px solid black;border-right:1px solid black;font-weight:bold;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <!-- SUBTITLE ROW -->
          <tr style="border-top:1px solid black;">
            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-left:1px solid black;border-left:1px solid black;border-right:1px solid black;">
              विवेक पुस्तक प्रकाशन
            </td>

            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;">
              Office Rep Very Briefly
            </td>

            <td style="font-size:16px; text-align:right; padding:8px; white-space:nowrap;border-right:1px solid black;font-weight:bold;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }}<br>
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

        </thead>
      </table>
    </div>

    <!-- ================= MAIN DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- COLUMN HEADER — REPEATS EACH PAGE -->
      <thead class="repeat-header">
        <tr style="font-weight:bold; ">

          <th style="border:1px solid black; padding:6px; font-size:16px;">
            Office Representative Name
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Invoice Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Paid Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Credit Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:16px; text-align:right;">
            Unpaid Amount
          </th>
        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody>

        <!-- LOOP EACH OFF REP -->
        <ng-container *ngFor="let data of OutstandingB">

          <tr>
            <td style="border:1px solid black; padding:8px; font-size:16px; ">
              {{ data.off_rep_name }}
            </td>

            <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.inv_Total }}
            </td>

            <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.paid_Total }}
            </td>

            <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.crdt_Total }}
            </td>

            <td style="border:1px solid black; padding:8px; font-size:16px; text-align:right;">
              {{ data.bal_Total }}
            </td>
          </tr>

        </ng-container>

        <!-- ================= GRAND TOTAL ================= -->
        <tr style="background:#c8753f; color:white; font-weight:bold; font-size:16px;">
          <td style="border:1px solid black; padding:8px;">
            Grand Total:
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalInvAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalPaidAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalCrdtAmount }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ totalUnpaidAmount }}
          </td>
        </tr>

      </tbody>

    </table>

  </div>

</div>




<div *ngIf="reportType == 'OfficeRepUnpaidbriefly'">

    <!-- ===== BUTTONS ===== -->
    <div style="margin-left: 80%; margin-top: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Office_Rep_UnpaidOutstanding_Brief_Report')" 
            mat-raised-button color="primary">
            Export
        </button>

        <button class="btn btn-primary noPrint" 
            style="margin-top: 2%; margin-left: 2%;"
            (click)="printPage42()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" 
            mat-button mat-dialog-close>
            Close
        </button>
    </div>

    <!-- ===== REPORT TABLE ===== -->
   <div class="container" id="print-section">

  <table class="table table-bordered">

    <!-- ================= HEADER ================= -->
    <thead>

      <!-- ===== TITLE ROW ===== -->
      <tr>
        <th colspan="1"
            style="border:1px solid black; font-size:18px; font-weight:bold;
                   text-align:center; padding:8px;">
          हिंदुस्तान प्रकाशन संस्था
        </th>

        <th colspan="2"
            style="border:1px solid black; font-size:20px; font-weight:bold;
                   text-align:center; padding:8px;">
          Book Outstanding Report
        </th>

        <th colspan="2"
            style="border:1px solid black; font-size:16px; font-weight:bold;
                   text-align:right; padding:8px; white-space:nowrap;">
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <!-- ===== SUB TITLE ROW ===== -->
      <tr>
        <th colspan="1"
            style="border:1px solid black; font-size:18px;
                   text-align:center; padding:8px; font-weight:bold;">
          विवेक पुस्तक प्रकाशन
        </th>

        <th colspan="2"
            style="border:1px solid black; font-size:18px;
                   text-align:center; padding:8px; font-weight:bold;">
          Office Rep Unpaid very Briefly
        </th>

        <th colspan="2"s
            style="border:1px solid black; font-size:16px;
                   text-align:right; padding:8px; font-weight:bold;
                   white-space:nowrap;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }}<br>
          To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <!-- ===== COLUMN HEADERS ===== -->
      <tr>
        <th style="border:1px solid black; padding:6px; font-size:16px;width:40%;">
          Office Rep Name
        </th>

        <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Invoice Amount
        </th>

        <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Paid Amount
        </th>

        <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Credit Amount
        </th>

        <th style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          Unpaid Amount
        </th>
      </tr>

    </thead>

    <!-- ================= BODY ================= -->
    <tbody>

      <tr *ngFor="let data of UnpaidOutstandingB">
        <td style="border:1px solid black; padding:6px; font-size:16px;">
          {{ data.off_rep_name }}
        </td>

        <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.inv_Total }}
        </td>

        <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.paid_Total }}
        </td>

        <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.crdt_Total }}
        </td>

        <td style="border:1px solid black; padding:6px;
                   font-size:16px; text-align:right;">
          {{ data.bal_Total }}
        </td>
      </tr>

      <!-- ===== GRAND TOTAL ===== -->
      <tr style="background-color:#c8753f; font-weight:bold; font-size:16px;">
        <td style="border:1px solid black; padding:6px;">
          Grand Total :
        </td>

        <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalInvAmount }}
        </td>

        <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalPaidAmount }}
        </td>

        <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalCrdtAmount }}
        </td>

        <td style="border:1px solid black; padding:6px; text-align:right;">
          Rs-{{ unpaidtotalUnpaidAmount }}
        </td>
      </tr>

    </tbody>

  </table>

</div>


</div>
